import { World } from "ecsy";
import { StateSystem } from "./systems/stateSystem";
import { LifeAndDeathSystem } from "./systems/lifeAndDeathSystem";
import { PhysicsSystem } from "./systems/physicsSystem";
import { AreaEffectSystem } from "./systems/areaEffectSystem";
import { DamageSystem } from "./systems/damageSystem";
import { MovementSystem } from "./systems/movementSystem";
import { TaggingSystem } from "./systems/taggingSystem";
import { ChainSystem } from "./systems/chainSystem";
import { JumpSystem } from "./systems/jumpSystem";
import { ShootSystem } from "./systems/shootSystem";
import { Game } from "./game";
import { MagnetSystem } from "./systems/magnetSystem";
import { SpawnSystem } from "./systems/spawnSystem";
import { SubmergeSystem } from "./systems/submergeSystem";
import { TriggeredEffectSystem } from "./systems/triggeredEffectSystem";
import { BuffSystem } from "./systems/buffSystem";
import { CooldownSystem } from "./systems/cooldownSystem";
import { AimSystem } from "./systems/aimSystem";
import { ConsumeSystem } from "./systems/consumeSystem";
import { getSystem } from "./utils";
import { AttractorSystem } from "./systems/attractorSystem";
import { ConditionalEffectSystem } from "./systems/conditionalEffectsSystem";
import { CombineSystem } from "./systems/combineSystem";
import { UnspentMoneySystem } from "./systems/unspentMoneySystem";
import { ElectricitySystem } from "./systems/electricitySystem";
import { cleanUpRemovedCellShopProteins } from "./entityFactory";

export function registerCommonSystemsPrePhysics(world: World, game: Game) {
	world
		.registerSystem(StateSystem, { game })
		.registerSystem(CombineSystem, { game })
		.registerSystem(LifeAndDeathSystem, { game }) //life death should be right next to physics
		.registerSystem(PhysicsSystem, { game })

	return world;
}

export function registerCommonSystemsPostPhysics(world: World, game: Game) {
	world
		.registerSystem(AreaEffectSystem, { game })
		.registerSystem(ChainSystem, { game })
		.registerSystem(DamageSystem, { game }) //anything not between damage and LifeDeath cannot see Dead component
		.registerSystem(TriggeredEffectSystem, { game }) //in front of damage so we can kill in response to trigger (but, moved. not sure if this was necessary, possible bug)
		.registerSystem(ConditionalEffectSystem, { game })
		.registerSystem(AimSystem, { game })
		.registerSystem(MovementSystem, { game })
		.registerSystem(AttractorSystem, { game })
		.registerSystem(MagnetSystem)
		.registerSystem(ElectricitySystem, { game })
		.registerSystem(CooldownSystem, { game })
		.registerSystem(ConsumeSystem, { game })
		.registerSystem(TaggingSystem, { game })
		.registerSystem(BuffSystem, { game })
		.registerSystem(JumpSystem, { game })
		.registerSystem(SubmergeSystem, { game }) //must come between lifeDeath and physics
		.registerSystem(ShootSystem, { game })
		.registerSystem(SpawnSystem, { game })
		.registerSystem(UnspentMoneySystem, { game });

	return world;
}

export function commonEndSimulation(game: Game) {
	game.inSimulation = false;

	const world = game.world;

	const chainSystem = getSystem(world, ChainSystem);
	chainSystem.chainsActive = false;
	chainSystem.persistedLinks.clear();

	game.lostCellsPerPlayerThisRound.clear();

	cleanUpRemovedCellShopProteins(game);
}

export function commonStartSimulation(game: Game) {
	game.recomputeWaveInfo();
	game.inSimulation = true;

	const world = game.world;

	const chainSystem = getSystem(world, ChainSystem);
	chainSystem.chainsActive = true;

}